import * as React from 'react';
import { Alert } from '@patternfly/react-core';
import type { Payload } from '../../../../shared/riskregister/types';

function formatTimestamp(value: string): string {
  const timestamp = new Date(value);
  return Number.isNaN(timestamp.getTime()) ? value : timestamp.toLocaleString();
}

function formatAge(ageMs: number | null): string {
  if (ageMs === null) return 'an unknown age';
  const minutes = Math.floor(ageMs / 60000);
  if (minutes < 1) return 'less than a minute old';
  if (minutes < 60) return `${minutes} minute${minutes === 1 ? '' : 's'} old`;
  const hours = Math.floor(minutes / 60);
  return `${hours} hour${hours === 1 ? '' : 's'} old`;
}

export const FreshnessBar: React.FunctionComponent<{ payload: Payload; isRefreshing: boolean }> = ({
  payload,
  isRefreshing,
}) => (
  <div className="risk-register__freshness" aria-live="polite">
    {payload.meta.fallback.active ? (
      <Alert variant="warning" title="Showing the last known good Risk Register">
        This fallback payload was fetched {formatTimestamp(payload.meta.fetched_at)} and is {formatAge(payload.meta.fallback.age_ms)}.
      </Alert>
    ) : (
      <Alert variant="info" title={`Data fetched ${formatTimestamp(payload.meta.fetched_at)}`}>
        {isRefreshing && 'Refreshing the live payload.'}
      </Alert>
    )}
  </div>
);
